import { FormProvider } from "react-hook-form";
import { useRegisterController } from "./useRegisterController";
import PersonalInformation from "./PersonalInformation";
import RegisterAddress from "./RegisterAddress";
import RegisterPassword from "./RegisterPassword";
import RegisterBank from "./RegisterBank";
import ValidateIdentity from "./ValidateIdentity";
import Analising from "./Analising";
import RegisterApproved from "./RegisterApproved";
import RegisterDenied from "./RegisterDenied";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { SwiperSlide, Swiper } from "swiper/react";
import login from "../../../assets/login.png";

const Register = () => {
  const { methods, currentStep, goToNextStep, handleSubmit, isPending, banners, isLoading } =
    useRegisterController();

  const renderStep = () => {
    switch (currentStep) {
      case "personal-information":
        return <PersonalInformation onNext={() => goToNextStep("address")} />;
      case "address":
        return (
          <RegisterAddress
            onNext={() => goToNextStep("password")}
            onBack={() => goToNextStep("personal-information")}
          />
        );
      case "password":
        return (
          <RegisterPassword
            onNext={() => goToNextStep("bank")}
            onBack={() => goToNextStep("address")}
          />
        );
      case "bank":
        return (
          <RegisterBank
            onSubmit={methods.handleSubmit(handleSubmit)}
            onBack={() => goToNextStep("password")}
            isPending={isPending}
          />
        );
      case "validate-identity":
        return (
          <ValidateIdentity goToNextStep={() => goToNextStep("analising")} />
        );
      case "analising":
        return <Analising goToNextStep={goToNextStep} />;
      case "RegisterApproved":
        return <RegisterApproved />;
      case "RegisterDenied":
        return <RegisterDenied />;
      default:
        return <PersonalInformation onNext={() => goToNextStep("address")} />;
    }
  };

  return (
    <div className="min-h-screen w-full flex flex-col xl:flex-row xl:min-h-screen">
      {!isLoading && banners && (
        <section className="hidden xl:block xl:w-[30%] xl:h-screen">
          {banners?.banners?.length > 0 ? (
            <Swiper
              modules={[Autoplay, Pagination, Navigation]}
              spaceBetween={0}
              slidesPerView={1}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
                el: ".swiper-pagination",
                bulletActiveClass: "bg-primary",
                bulletClass:
                  "inline-block w-1.5 h-1.5 rounded-full bg-white/50 mx-1 cursor-pointer transition-all",
              }}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              loop={true}
              className="aspect-[720/1080] h-full grow rounded-lg"
            >
              {banners.banners.map((banner, index) => (
                <SwiperSlide key={index} className="z-0">
                  <a
                    href={banner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block h-full w-full"
                  >
                    <img
                      src={`${import.meta.env.VITE_CDN_URL}${banner.uri}`}
                      alt=""
                      className="aspect-[720/1080] h-full object-fill"
                      loading="lazy"
                    />
                  </a>
                </SwiperSlide>
              ))}

              <div className="swiper-pagination !bottom-2"></div>
            </Swiper>
          ) : (
            <img
              src={login}
              alt=""
              className="aspect-[720/1080] h-full object-fit"
              loading="lazy"
            />
          )}
        </section>
      )}
      <section className="flex flex-1 w-full flex-col items-center justify-start px-4 py-6 xl:w-[70%] xl:px-8 xl:py-12">
        <FormProvider {...methods}>
          <div className="w-full max-w-md sm:max-w-lg lg:max-w-xl xl:max-w-2xl">{renderStep()}</div>
        </FormProvider>
      </section>
    </div>
  );
};

export default Register;
